import { useQuery, UseQueryResult } from 'react-query';
import { MediaApi } from 'api/media';
import { MediaLibraryAlbum } from 'types/MediaLibrary';
import { queryKey } from 'constants/queryKey';
import {
  AlbumScope,
  albumScopeListParams,
  isBrowsableScope,
} from 'app/modules/mediaLibraryPage/utils/albumScope';

export default function useAlbumsForPage(
  scope: AlbumScope | undefined,
): UseQueryResult<MediaLibraryAlbum[]> {
  return useQuery(
    queryKey.mediaLibraryPage.albums(scope ?? 0),
    () =>
      isBrowsableScope(scope)
        ? MediaApi.listAlbums({ ...albumScopeListParams(scope), limit: 100 })
        : Promise.resolve([]),
    { enabled: isBrowsableScope(scope) },
  );
}
